import AppDataSource            from "./App/AppDataSource";
import Palettes                 from "../../../Domain/Palette/Store/Palettes";
import User                     from "../../../Domain/User/Store/User";
import ApiDataSource            from "./Api/ApiDataSource";
import PalettesWatcher          from "../Persistance/PalettesWatcher";
import MilestoneActionsListener from "../../Events/MilestoneActionsListener";
import Palette                  from "../../../Domain/Palette/Palette";
import UserModel                from "../../../Domain/User/User";

export default class DataLoader {

    constructor() {
        this.palettes = new Palettes();
        this.user     = new User();
    }

    load() {
        this.loadDefaultData();
        this.attemptToLoadDataFromApi();
    }

    loadDefaultData() {
        this.palettes.set(new AppDataSource().get());
    }

    async attemptToLoadDataFromApi() {
        let source = new ApiDataSource();
        let data   = await source.get();

        if(data && data.user && data.palettes) {
            this.palettes.set(Palette.makeArray(data.palettes));
            this.user.set(data.user);
            new PalettesWatcher();
        }
        else { // not logged in
            new MilestoneActionsListener();
        }
    }
}
